export default __webpack_public_path__ + "img/gfx_events_across_apac-50a5ad946b623f18e1b6e6491823a41b.png";